module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.playerDirty) ? _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "toggleButton",
    on: {
      "click": _vm.toggleShown
    }
  }, [_c('iconify-icon', {
    staticClass: "fa",
    attrs: {
      "icon": _vm.playerShown ? 'fa6-solid:chevron-down' : 'fa6-solid:chevron-up'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Show/hide player")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerShown),
      expression: "playerShown"
    }],
    staticClass: "playerModule"
  }, [(_vm.playingEpisode) ? _c('player-container', {
    attrs: {
      "playingEpisode": _vm.playingEpisode,
      "audioSource": _vm.audioSource
    }
  }) : _c('player-placeholder')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3573865d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Player.vue
// module id = 770
// module chunks = 1